<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-file-circle-check"></i></div>
      <div>
        Liste des apprenants
        <div class="page-title-subheading">Gestion des livra apprenants</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="d-flex justify-content-center">
        <div class="form-group">
            <label for="">Choisir la classe</label>
            <ng-select (change)="loadData2($event)">
                <ng-option *ngFor="let classroom of classrooms" [value]="classroom.id">{{classroom?.name}}</ng-option>
            </ng-select>
        </div>
    </div>


    <div class="row">
        <div class="col-lg-12">
            <div class="card">
          
                <div class="card-body">
                    <div class=" " *ngIf="buttonsPermission">
                        <div class="d-flex justify-content-between mb-5">
                            <div class=" " *ngIf="buttonsPermission">
                                <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                                   Ajouter une dispense</button>
                                <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                     Supprimer</button>
                                     <button *ngIf="selected_data && is_active!=null && !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                        Activer</button>
                                       <button  *ngIf="selected_data && is_active!=null && is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                        Désactiver</button>
                            </div>
        
                            <div class="form-group ms-auto">
                                <label for=""> <strong>Rechercher:</strong> </label>
                                <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                            </div>
                        </div>
                    </div>
    
                            <p>{{data!.length}} élément(s)</p>
                            <div class="table-responsive">
                            <table class="table" >
                                <thead class="">
                                    <tr>
                                        <th style="width: 10px;">#</th>
                                        <th>Apprenant</th>
                                        <th >Nature de dispense</th>
                                        <th >Fichier</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data  | sampleSearch:search_text:'rooms' | paginate: {
                                    id:'ngxP1',
                                    itemsPerPage: pg.pageSize,
                                    currentPage: pg.p,
                                    totalItems: pg.total }">
                                        <td>
                                            <div class="form-check mb-2">
                                                <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                            
                                            </div>
                                        </td>
                                        <td>
                                            {{d.identity}}
                                        </td>
                                        <td>
                                            <dl>
                                                <dt>{{d.dispensiation_type}}</dt>
                                                <dd *ngIf="d.delay">{{d.delay}}</dd>
                                            </dl>
                                        </td>
                                        <td>
                                            <button *ngIf="d.dispensiation_filename" class="btn btn-sm btn-outline-primary" (click)="getFile(d.code,'',d.dispensiation_filename)">Ouvrir</button>

                                        </td>
                                    
                                    </tr>
                                
                                </tbody>
                            </table>
                            </div>
                            <pagination-controls 
                            id="ngxP1"
                            (pageChange)="getPage($event)"
                          [maxSize]="9"
                          [directionLinks]="true"
                          [autoHide]="true"
                          [responsive]="true"
                          [previousLabel]="'Précédent'"
                          [nextLabel]="'Suivant'"
                          [screenReaderPaginationLabel]="'Pagination'"
                          [screenReaderPageLabel]="'page'"
                          [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                         </pagination-controls>
    
                </div><!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end col -->
    </div>
    
    
    <ng-template #addContent let-c="close" let-d="dismiss">
        <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Générer un livrable pour l'apprenant</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
            <div class="row mb-3" >
              
           
            </div>
           
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
        </div>
    </form>
      </ng-template>
    
      <ng-template #editContent let-c="close" let-d="dismiss">
        <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Ajouter une dispense</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
            <div class="row mb-3" >
                <div class="form-group ">
                    <label for="">Choisir le type de dispense</label>
                    <ng-select name="dispensiation_type" [(ngModel)]="selected_data.dispensiation_type">
                        <ng-option selected disabled></ng-option>
                        <ng-option *ngFor="let dt of dispensation_types" [value]="dt">{{dt}}</ng-option>
                    </ng-select>
                </div>
                <div class=" form-group col-12 mb-3" *ngIf="selected_data.dispensiation_type=='Ponctuelle'" >
                    <label for="">Délai de dispense <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="delay" class="form-control" [(ngModel)]="selected_data.delay">
                </div> 
                <div class=" form-group col-12 mb-3">
                    <label for="">PJ</label>
                    <input type="file" class="form-control" ngModel (change)="upload($event)" >
                </div>
             
            </div>
           
           
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
        </div>
    </form>
      </ng-template>

 
    
      <ng-template #contentPDF let-offcanvas>
        <div class="offcanvas-header">
        
            <h4 class="offcanvas-title">Visualiseur de fichier</h4>
            <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
        </div>
        <div class="offcanvas-body">
            <ngx-extended-pdf-viewer [src]="pdfSrc"
            style="width: 100%; height: 100%"
            ></ngx-extended-pdf-viewer>
        </div>
    </ng-template>